import React, { useState, useEffect } from 'react';
import axios from 'axios';

function MerchantReviews({ merchantId }) {
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [avgRating, setAvgRating] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchReviews = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/merchants/${merchantId}/reviews?page=${page}&limit=5`);
      setAvgRating(res.data.average_rating);
      setTotal(res.data.total);
      setReviews(prev => (page === 1 ? res.data.reviews : [...prev, ...res.data.reviews]));
    } catch (err) {
      console.error('加载评价失败', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [page, merchantId]);

  const loadMore = () => setPage(p => p + 1);

  return (
    <div style={{ marginTop: '24px' }}>
      <h3>顾客评价（总评分 {avgRating}，共 {total} 条）</h3>
      {reviews.length === 0 && !loading && <p>暂无评价</p>}
      {reviews.map(review => (
        <div key={review.id} style={{ borderBottom: '1px solid #eee', marginBottom: '16px', paddingBottom: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <strong>{review.user_name || '匿名用户'}</strong>
            <span>{'★'.repeat(review.overall_rating)}{'☆'.repeat(5 - review.overall_rating)}</span>
            <span style={{ fontSize: '12px', color: '#666' }}>{new Date(review.created_at).toLocaleString()}</span>
          </div>
          <p>{review.comment}</p>
          <div style={{ display: 'flex', gap: '8px' }}>
            {review.images.map((url, idx) => (
              <img key={idx} src={url} alt="" style={{ width: '60px', height: '60px', objectFit: 'cover' }} />
            ))}
          </div>
          {review.product_reviews?.length > 0 && (
            <div style={{ background: '#f9f9f9', padding: '8px', marginTop: '8px' }}>
              <strong>商品评价：</strong>
              {review.product_reviews.map(pr => (
                <div key={pr.product_id}>{pr.product_name}：评分 {pr.rating}，{pr.comment}</div>
              ))}
            </div>
          )}
        </div>
      ))}
      {reviews.length < total && (
        <button onClick={loadMore} disabled={loading}>加载更多</button>
      )}
    </div>
  );
}

export default MerchantReviews;